import { AbstractControl } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import { filter, map, take, withLatestFrom } from 'rxjs/operators'
import * as R from 'ramda'
import { isSomething, convertToTokeetEmail } from '../functions'
import { selectAllRentals, selectSubdomain, Rental } from '../stores'

// @dynamic
export class RentalEmailNotTakenValidator {
  static createValidator(store: Store<any>, rentalId?: string) {
    return (control: AbstractControl) => {
      return store.pipe(
        select(selectAllRentals),
        filter((rentals) => isSomething(rentals)),
        take(1),
        withLatestFrom(store.pipe(select(selectSubdomain), take(1))),
        map(([rentals, subDomain]) => ({ rentals, subDomain })),
        map(({ rentals, subDomain }) => {
          if (rentalId) {
            const withoutRental = R.filter((r: Rental) => r.id !== rentalId, rentals)
            return isRentalEmailTaken(control.value, subDomain, withoutRental)
          }
          return isRentalEmailTaken(control.value, subDomain, rentals)
        })
      )
    }
  }
}

export function isRentalEmailTaken(email: string, subDomain: string, rentals: Rental[]) {
  return R.any((r: Rental) => r.email === convertToTokeetEmail(email, subDomain))(rentals) ? { emailTaken: true } : null
}
